import * as React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import "./SignOut.scss";
import { UcThemeContext } from '../../lib/UcThemeProvider';
import CircularProgress from '@mui/material/CircularProgress';
import { ApiClient } from '../../lib/ApiClient';
import { useAuthenticated } from '../auth/useAuthenticated'
import axios from 'axios';
import { getUrl, useDomainNavigate } from '../../domain';

const apiClient = new ApiClient();

export default function SignOut() {
    // get logoutId from queryparam
    let logoutId = new URLSearchParams(window.location.search).get('logoutId');
    // need to encode logoutId
    logoutId = encodeURIComponent(logoutId);
    let navigate = useDomainNavigate();
    const formRef = React.useRef();

    const userAuth = useAuthenticated(apiClient);
    const hasAutoSignOut = React.useRef(false);
    const [isLoading, setIsLoading] = React.useState(true);
    // eslint-disable-next-line no-unused-vars
    const [themeState, themeDispatch] = React.useContext(UcThemeContext);

    if (!userAuth.isAuthenticating && !userAuth.isAuthenticated) {
        navigate("/account/login");
    }

    React.useEffect(() => {
        if (!hasAutoSignOut.current && formRef.current && logoutId) {
            hasAutoSignOut.current = true;
            axios.get(getUrl("/identity/account/logoutInfo?logoutId=" + logoutId))
                .then(response => {
                    let autoSignout = new URLSearchParams(response.data.queryString.toLowerCase()).get('autosignout');
                    let userThemePreference = new URLSearchParams(response.data.queryString.toLowerCase()).get('userThemePreference') || 'light';
                    let subdomain = new URLSearchParams(response.data.queryString.toLowerCase()).get('subdomain') || 'default';
                    subdomain = subdomain.replace('qa-', '');

                    if (subdomain !== undefined && userThemePreference !== undefined && themeState.themeName !== subdomain && themeState.mode !== userThemePreference) {
                        themeDispatch({ name: subdomain, mode: userThemePreference });
                    }

                    if (autoSignout === "true") {
                        formRef.current.submit();
                    }
                    else {
                        setIsLoading(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    setIsLoading(false);
                });
        }
        else if (!logoutId) {
            setIsLoading(false);
        }
    }, [logoutId, isLoading, setIsLoading, themeState, themeDispatch]);

    const display = isLoading ? "none" : "flex";

    return (
        <>
            {isLoading &&
                <Box sx={{ mt: 1, textAlign: 'center' }}>
                    <CircularProgress color="primary" size={40} aria-label="Loading..." title="Loading..." />
                </Box>
            }
            <Box
                sx={{
                    marginTop: 0,
                    display: display,
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography variant="subtitle1" gutterBottom component="div">
                    Would you like to sign out?
                </Typography>
                <form ref={formRef} action={getUrl("/identity/account/logout?logoutId=" + logoutId)} method="POST" >
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Yes
                    </Button>
                </form>
            </Box>
        </>
    );
}